import { render } from "./customRafflePage.vue?vue&type=template&id=031225e8&scoped=true"
import script from "./customRafflePage.vue?vue&type=script&lang=js"
export * from "./customRafflePage.vue?vue&type=script&lang=js"

import "./customRafflePage.vue?vue&type=style&index=0&id=031225e8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031225e8"]])

export default __exports__